(function () {
  'use strict';


  angular
    .module('operationsSummaryReport')
    	.directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
    .controller('OperationsSummaryReportCtrl', OperationsSummaryReportCtrl);

  function OperationsSummaryReportCtrl($sce,CommonMasterData,MessageService,CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'operationsSummaryReport';

    vm.model = {
            searchPanelToggle:true,
            searchCriteria:{
            	fromDate:null,
              toDate:null,
              origins:null,
              destinations:null,
              airCraftType:null,
              status:null
            },
            masterList: {
            	airportList:[],
              airCraftTypes:[],
              fromDateFormatInvalid : false,
              toDateFormatInvalid : false,
              fromDateAfterToDate : false,
              statusList:[]
            },
            initialSearchDone:false,
            reportServerBaseUrl : null,
            reportDataUrl : ""
        };

    vm.model.masterList.statusList = [
      {title:'All', value: 'ALL'},
      {title:'Scheduled', value: 'SCH'},
      {title:'Deleted', value: 'DEL'},
      {title:'Cancelled', value: 'CNX'}
    ];

    vm.clickOnSearch = function () {
        vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
        vm.model.initialSearchDone=false;
    };

    vm.submitSearch = function (params){
    	search(params);
    };


    vm.changeSearchField = function(searchParams, flag) {
      setDateValidationFlags();
      if (!!vm.model.searchCriteria.fromDate
        && !!vm.model.searchCriteria.toDate
        && !vm.model.masterList.fromDateFormatInvalid
        && !vm.model.masterList.toDateFormatInvalid
        && !isFromDateBeforeToDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }
    };

    function setDateValidationFlags() {
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }

    function isFromDateBeforeToDate() {
      return moment(
        vm.model.searchCriteria.fromDate,
        "DD/MM/YYYY").isBefore(
        moment(vm.model.searchCriteria.toDate,
          "DD/MM/YYYY"));
    };


    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }


      function search(params){
    	vm.model.searchPanelToggle = false;
    	vm.model.ruleList = [];
    	vm.model.searchCriteria = params;
    	var url = CommonLogicService.getReportUrl('operations_summary_report.rptdesign',getSearchParamMap(params));
    	vm.model.reportDataUrl = $sce.trustAsResourceUrl(url);
    }

    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      searchParamMap["referrer"] = window.location.origin;

      if (!!param.origins && param.origins.length>0) {
        searchParamMap["origins"] = createCommaSeparatedString(param.origins,'airPortCode');
      }

      if (!!param.destinations && param.destinations.length >0) {
        searchParamMap["destinations"] = createCommaSeparatedString(param.destinations,'airPortCode');
      }

      if(!!param.airCraftType && !!param.airCraftType.airCraftType){
        searchParamMap["airCraftType"] = param.airCraftType.airCraftType;
      }

      if(!!param.status && !!param.status.value){
        searchParamMap["status"] = param.status.value;
      }

      return searchParamMap;
    }


    function createCommaSeparatedString(list, valueFieldName) {
      if(list === null || list.length === 0 || angular.isUndefined(list)){
        return "";
      }

      var commaSeparatedString = '';
      for (var j = 0; j < list.length; j++) {
        var  obj = Object(list[j]);
        if (j == 0) {
          commaSeparatedString = obj[valueFieldName];
        } else {
          commaSeparatedString += ',' + obj[valueFieldName];
        }
      }
      return commaSeparatedString;
    }


    CommonMasterData.getAirportList(
      function (airports) {

        var List = [];

        angular.forEach(airports, function (apt) {
          if(apt.icaoCode != null){
            List.push(apt);
          }
        });
        vm.model.masterList.airportList = List;
      },
      function () {
        console.log('origin/Destination Airport retrieval error');
      }
    );

    CommonMasterData.getReportServerBaseUrl(
	    	function (baseUrl) {
	            vm.model.reportServerBaseUrl = baseUrl;
	        },
	        function (error) {
	            MessageService.error(error);
	        }
	    );


    CommonMasterData.getAircraftModels(function (airCraftList) {
      vm.model.masterList.airCraftTypes = airCraftList;
    }, function (error) {});

  }


}());
